
        import { FigmintOutput } from 'figmint'

        const styles: FigmintOutput = {
  fillStyles: [
    {
      key: '131b07a7528e1acd532ea47f73075f17c0b9223b',
      name: 'Orange',
      styles: [
        {
          type: 'SOLID',
          blendMode: 'NORMAL',
          color: 'hsla(0, 100%, 46%, 0.49)'
        },
        {
          type: 'SOLID',
          blendMode: 'NORMAL',
          color: 'hsl(28, 87%, 62%)'
        }
      ]
    },
    {
      key: '38b08cba6e83a08ea295eabd2c3241001e8c8b86',
      name: 'Green',
      styles: [
        {
          type: 'SOLID',
          blendMode: 'NORMAL',
          color: 'hsl(133, 68%, 42%)'
        }
      ]
    },
    {
      key: '8122e3ffd5bb844b86b892e7e77a7695d9a6922c',
      name: 'Red',
      styles: [
        {
          type: 'SOLID',
          blendMode: 'NORMAL',
          color: 'hsl(7, 79%, 63%)'
        }
      ]
    },
    {
      key: 'a8a285994aa055d08418169899a924c593eb642b',
      name: 'Blue to Green',
      styles: [
        {
          type: 'GRADIENT_LINEAR',
          blendMode: 'NORMAL',
          stops: [
            {
              color: 'hsl(216, 100%, 50%)',
              y: 0,
              x: undefined
            },
            {
              color: 'hsl(191, 100%, 55%)',
              y: 0.5310521125793457,
              x: undefined
            },
            {
              color: 'hsl(122, 97%, 75%)',
              y: 1,
              x: undefined
            }
          ]
        }
      ]
    },
    {
      key: 'ead2894a9aa677b9c052129a2ff3f08d783d15bf',
      name: 'Image',
      styles: [
        {
          type: 'IMAGE',
          blendMode: 'NORMAL',
          fileName: 'figma/fillImages/744e48e82e6dcb47349ccdb60a064c30484efc16.png'
        }
      ]
    }
  ],
  textStyles: [
    {
      key: '489a276a212cab74c777319118aa08f3dce342f0',
      name: 'h1',
      styles: {
        fontFamily: 'Verdana',
        fontPostScriptName: 'Verdana',
        fontWeight: 400,
        fontSize: 36,
        textAlignHorizontal: 'LEFT',
        textAlignVertical: 'TOP',
        letterSpacing: 0,
        lineHeightPx: 48,
        lineHeightPercent: 113.77777862548828,
        lineHeightPercentFontSize: 133.3333282470703,
        lineHeightUnit: 'PIXELS',
        lineHeight: 1.3333333333333333,
        fontStyle: 'inherit'
      }
    },
    {
      key: '7ecd33c504acf0ea58e1a0022ae962dfec9fe273',
      name: 'h2',
      styles: {
        fontFamily: 'Georgia',
        fontPostScriptName: 'Georgia-Bold',
        fontWeight: 700,
        fontSize: 24,
        textAlignHorizontal: 'LEFT',
        textAlignVertical: 'TOP',
        letterSpacing: 0,
        lineHeightPx: 28.125,
        lineHeightPercent: 100,
        lineHeightUnit: 'INTRINSIC_%',
        lineHeight: 1.171875,
        fontStyle: 'inherit'
      }
    },
    {
      key: '389f80d43bf34d2ff5ec2ee33cee7ec92fe279ee',
      name: 'h3',
      styles: {
        fontFamily: 'Arial',
        fontPostScriptName: 'Arial-BoldItalicMT',
        italic: true,
        fontWeight: 700,
        fontSize: 18,
        textAlignHorizontal: 'LEFT',
        textAlignVertical: 'TOP',
        letterSpacing: 0,
        lineHeightPx: 21.09375,
        lineHeightPercent: 100,
        lineHeightUnit: 'INTRINSIC_%',
        lineHeight: 1.171875,
        fontStyle: 'italic'
      }
    }
  ],
  effectStyles: [],
  gridStyles: [],
  exports: [
    {
      id: '328:40',
      format: 'png',
      scale: 1,
      url: 'figma/exports/images/pngImage.png',
      directory: 'figma/exports/images',
      file: 'pngImage.png'
    },
    {
      id: '328:42',
      format: 'jpg',
      scale: 2,
      url: 'figma/exports/images/jpgAndPngImage.jpg',
      directory: 'figma/exports/images',
      file: 'jpgAndPngImage.jpg'
    },
    {
      id: '328:42',
      format: 'png',
      scale: 2,
      url: 'figma/exports/images/jpgAndPngImage.png',
      directory: 'figma/exports/images',
      file: 'jpgAndPngImage.png'
    },
    {
      id: '335:3',
      format: 'svg',
      scale: 1,
      url: 'figma/exports/icons/build.svg',
      directory: 'figma/exports/icons',
      file: 'build.svg'
    },
    {
      id: '328:41',
      format: 'svg',
      scale: 1,
      url: 'figma/exports/icons/explore.svg',
      directory: 'figma/exports/icons',
      file: 'explore.svg'
    }
  ]
}

        
          export type SolidColors = | 'hsla(0, 100%, 46%, 0.49)'| 'hsl(28, 87%, 62%)'| 'hsl(133, 68%, 42%)'| 'hsl(7, 79%, 63%)'
          export type FillNames = | 'Orange'| 'Green'| 'Red'| 'Blue to Green'| 'Image'
          export type TextNames = | 'h1'| 'h2'| 'h3'
          

        export default styles